import React, { useState } from 'react';
import { ShieldCheckIcon, ScaleIcon, UserCheckIcon, FileSearchIcon, ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
export function SecurityFAQ() {
  const trustItems = [{
    icon: <FileSearchIcon className="h-6 w-6" data-id="element-1571" />,
    title: 'Evaluación personalizada',
    description: 'Analizamos tu caso específico para ofrecerte la mejor propuesta.'
  }, {
    icon: <ScaleIcon className="h-6 w-6" data-id="element-1572" />,
    title: 'Estructura legal clara',
    description: 'Contratos transparentes y regulados bajo la normativa vigente.'
  }, {
    icon: <UserCheckIcon className="h-6 w-6" data-id="element-1573" />,
    title: 'Atención directa',
    description: 'Asesor personal dedicado a resolver todas tus dudas.'
  }, {
    icon: <ShieldCheckIcon className="h-6 w-6" data-id="element-1574" />,
    title: 'Sin letra chica',
    description: 'Transparencia total en costos, plazos y condiciones.'
  }];
  const faqs = [{
    question: '¿Pierdo la propiedad?',
    answer: 'No. Mantienes el derecho de uso y disfrute de la propiedad durante todo el período acordado. La propiedad sigue siendo tu hogar.'
  }, {
    question: '¿Es una venta?',
    answer: 'No es una venta tradicional. Es un mecanismo de monetización donde cedes derechos futuros a cambio de liquidez presente, pero mantienes el uso del inmueble.'
  }, {
    question: '¿Es un crédito?',
    answer: 'No es un crédito bancario tradicional. No genera deuda en el sistema financiero convencional y no requiere pagos mensuales de tu parte; al contrario, tú recibes los pagos.'
  }, {
    question: '¿Qué pasa si fallezco?',
    answer: 'El contrato incluye cláusulas de heredabilidad. Tus beneficiarios seguirán recibiendo los pagos mensuales restantes hasta completar el período acordado.'
  }, {
    question: '¿Qué pasa después de 15 años?',
    answer: 'Al finalizar el plazo, existen opciones de renovación, venta o recompra según lo estipulado en el contrato inicial. Todo queda definido desde el primer día.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-16 md:py-24 bg-white" data-id="element-1575">
      <div className="container mx-auto max-w-6xl px-4" data-id="element-1576">
        {/* Trust Section */}
        <div className="text-center mb-16" data-id="element-1577">
          <h2 className="text-3xl md:text-4xl font-bold text-[#0A1628] mb-4" data-id="element-1578">
            Seguridad y Transparencia
          </h2>
          <p className="text-lg text-[#6B7280] mb-12" data-id="element-1579">
            Tu tranquilidad es nuestra prioridad. Sin obligación hasta firmar
            contrato.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-1580">
            {trustItems.map((item, index) => <div key={index} className="flex flex-col items-center text-center p-4" data-id="element-1581">
                <div className="w-14 h-14 rounded-full bg-[#E8EDF5] flex items-center justify-center text-[#2B5FD9] mb-4" data-id="element-1582">
                  {item.icon}
                </div>
                <h3 className="text-lg font-bold text-[#0A1628] mb-2" data-id="element-1583">
                  {item.title}
                </h3>
                <p className="text-sm text-[#6B7280]" data-id="element-1584">{item.description}</p>
              </div>)}
          </div>
        </div>

        {/* FAQ Section */}
        <div className="max-w-3xl mx-auto" data-id="element-1585">
          <h3 className="text-2xl font-bold text-[#0A1628] mb-8 text-center" data-id="element-1586">
            Preguntas Frecuentes
          </h3>
          <div className="space-y-4" data-id="element-1587">
            {faqs.map((faq, index) => <div key={index} className="border border-gray-200 rounded-xl overflow-hidden transition-all duration-200 hover:border-[#2B5FD9]/30" data-id="element-1588">
                <button className="w-full flex items-center justify-between p-5 text-left bg-white hover:bg-gray-50 transition-colors" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-1589">
                  <span className="font-semibold text-[#0A1628] pr-4" data-id="element-1590">
                    {faq.question}
                  </span>
                  {openIndex === index ? <ChevronUpIcon className="h-5 w-5 text-[#2B5FD9] flex-shrink-0" data-id="element-1591" /> : <ChevronDownIcon className="h-5 w-5 text-gray-400 flex-shrink-0" data-id="element-1592" />}
                </button>
                {openIndex === index && <div className="p-5 pt-0 bg-white text-[#6B7280] text-sm leading-relaxed border-t border-gray-100 mt-2" data-id="element-1593">
                    {faq.answer}
                  </div>}
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}